// src/components/marketing/CampaignsPage.tsx
//
// Entry component registered under `mkt-meta/campaigns`. Routes with a
// `:subId` param drill into the detail view; otherwise the list renders.
// Keeps `routes/pages.tsx` a flat (module, tab) dispatcher — sub-routes
// live inside the owning page.

import { useParams } from 'react-router-dom';

import { CampaignsList } from './CampaignsList';
import { CampaignDetail } from './CampaignDetail';

type Notifier = Parameters<typeof CampaignsList>[0]['addNotification'];

interface Props {
  addNotification?: Notifier;
}

export function CampaignsPage({ addNotification }: Props) {
  const { subId } = useParams<{ subId?: string }>();
  if (subId) {
    const id = Number.parseInt(subId, 10);
    if (!Number.isFinite(id) || id <= 0) {
      // Fall back to list when the URL has a junk id.
      return <CampaignsList addNotification={addNotification} />;
    }
    return <CampaignDetail campaignId={id} addNotification={addNotification} />;
  }
  return <CampaignsList addNotification={addNotification} />;
}

export default CampaignsPage;
